/**
 * Query-string key carrying an ad-hoc RoboQL filter for a resource list, as in
 * `/events?query=event_id%20%3D%20%22ev_1%22`.
 *
 * Lives in the domain beside `VIEW_SEARCH_PARAM` for the same reason: code
 * outside the list (a link builder) has to write the key the list reads.
 */
export const ROBOQL_SEARCH_PARAM = "query";

/** A path to the list at `pathname`, opened filtered by the RoboQL `query`. */
export function roboqlLinkTo(pathname: string, query: string): string {
  const params = new URLSearchParams({ [ROBOQL_SEARCH_PARAM]: query });
  return `${pathname}?${params.toString()}`;
}
